/*
*递归约束
*/
let _toString = Object.prototype.toString;

function _extend(data, struct) {
    //
    let _data;
    switch (_toString.call(data)) {
    case '[object Object]':
        _data = {};
        //
        if (struct) {
            for (let o in struct) {
                if (data.hasOwnProperty(o)) {
                    if (struct.hasOwnProperty(o)) {
                        let _type = _toString.call(data[o]);
                        if (_type === '[object Array]') {
                            //[{}]
                            _data[o] = _extend(data[o], struct[o][0]);
                        } else if (_type === '[object Object]') {
                            //{}
                            _data[o] = _extend(data[o], struct[o]);
                        } else if(_type === '[object Number]' || _type=== '[object Boolean]'){
                            _data[o] = data[o];
                        }else {
                            //值类型直接赋值,兼顾 data[o]=null 的情况
                            _data[o] = data[o] || struct[o];
                        }
                    }
                } else {
                    //没有的话给定默认值
                    _data[o] = struct[o];
                }
            }
        } else {
            for (let s in data) {
                _data[s] = _extend(data[s]);
            }
        }
        return _data;
        break;
    case '[object Array]':
        _data = [];
        for (let i = 0; i < data.length; i++) {
            //
            if (struct) {
                //[{}]
                _data[i] = _extend(data[i], struct);
            } else {
                _data[i] = _extend(data[i]);
            }
        }
        return _data;
        break;
    default:
        return data;
    }
}

//
function DataStruct(struct) {
    if (_toString.call(struct) != '[object Object]') {
        throw 'struct must be object';
    }
    this._struct = struct;
    this.defaultArray = [struct];
    this.defaultDataObject = struct;

    this.emptyArray = [];
    this.emptyObject = {};
}

DataStruct.prototype.extend = function(data, noConstraint) {
    let self = this;
    if (!noConstraint) {
        return _extend(data, self._struct);
    } else {
        return _extend(data);
    }
};
//深克隆
DataStruct.extend = function(data, q) {
    return _extend(data, q);
};
export { DataStruct };
